import {Component, OnInit, AfterViewInit, OnDestroy} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import { StorageService } from '../../../../Services/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SysUserModel } from '../../../../DataModels/sys-user-model';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmDialogService } from '../../../../Services/confirm-dialog.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { BsToastService } from '../../../../Services/bs-toast-service';
import {Subscription, take} from 'rxjs';

@Component({
  selector: 'app-sys-user-form',
  templateUrl: './sys-user-form.component.html',
  styleUrls: ['./sys-user-form.component.css'],
  standalone: false
})
export class SysUserFormComponent implements OnInit, AfterViewInit, OnDestroy {
  vm: any = {};
  sysUser: SysUserModel;
  sysUserForm: UntypedFormGroup;
  submitted = false;
  isLoaded = false;
  originalSnapshot: any = {};

  buttonConfig: any = {
    save: true,
    close: true,
    reset: false,
    delete: true,
    saveNew: false,
    saveClose: true,
    print: false,
  };
  locales = [
    { id: 'en', name: 'United States' },
    { id: 'gb', name: 'England' },
    { id: 'cn', name: 'Canada' },
    { id: 'es', name: 'Mexico' },
    { id: 'fr', name: 'France' },
    { id: 'cn', name: 'China' },
  ];

  preferences = {
    default_company_id: '',
    ShowBatches: false,
    QuickLinks: {},
  };

  deleteButtonDisabled = true;
  subscriptionGroup: Subscription[] = [];
  selectedCopyUserId: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private datePipe: DatePipe,
    private decimal: DecimalPipe,
    private titleService: Title,
    private formBuilder: UntypedFormBuilder,
    private confirmDialogService: ConfirmDialogService
  ) {
    this.vm.item = { id: undefined };

    // set to correct value later below
    this.vm.Permissions = {};

    this.createForm();

    this.vm.sys_user_id = this.route.snapshot.params.id;
  }

  createForm() {
    this.sysUserForm = this.formBuilder.group({
      name: new UntypedFormControl('', [Validators.required]),
      defaultCompany: new UntypedFormControl(''),
      email: new UntypedFormControl('', [Validators.required]),
      active: new UntypedFormControl(''),
      showBatches: new UntypedFormControl(false),
      admin_user: new UntypedFormControl(false),
    });
  }

  get user() {
    return this.sysUserForm.controls;
  }

  get f() {
    return this.sysUserForm.controls;
  }

  SetValue() {
    this.sysUserForm.patchValue({
      name: this.vm.item.name,
      email: this.vm.item.email,
      active: this.vm.item.active,
      admin_user: this.vm.item.admin_user,
      defaultCompany: this.vm.Preferences.default_company_id,
      showBatches: this.vm.Preferences.ShowBatches,
    });
    // console.log('control show: ' + this.vm.item.Preferences.ShowBatches);
  }

  ngOnInit() {
    this.isLoaded = false;
    this.vm.title = $localize`:System User @@systemUser:System User`;
    this.init();
    this.isLoaded = true;
    if (this.vm.sys_user_id === 'new') {
      Promise.resolve().then(() => {
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscriptionGroup.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  saveClose() {
    if (this.onSave(true)) {
    }
  }

  saveNew() {}

  deleteItem() {
    let retMsg = '';
    const messages: string[] = [
      $localize`:Are you sure you want to delete user? @@areYouSureYouWantToDeleteUser:Are you sure you want to delete user?`,
      this.sysUser.name,
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.subscriptionGroup.push(this.tableDataService.deleteDataById('sys_user', this.sysUser.id).subscribe(
          (result) => {
            retMsg = result;
            this.notification.showSuccessToast($localize`:Deleted Canceled@@deleted:Deleted`);
          },
          (error: HttpErrorResponse) => {
            console.log(error);
          },
          () => {
            this.onClose();
          }
        ));
      },
      () => {
        this.notification.showSuccessToast($localize`:Delete Canceled@@deleteCanceled:Delete Canceled`);
      }
    );
  }

  resetForm() {
    // this.sysUserForm.reset();
    try {
      this.originalSnapshot = this.buildSnapshot();
    } catch {
    }
  }

  onClose() {
    this.router.navigateByUrl('admin/sys-user/list').then();
  }

  init() {
    this.isLoaded = false;

    if (this.vm.sys_user_id !== 'new') {
      this.buttonConfig.reset = false;
      this.subscriptionGroup.push(this.tableDataService.getData('sys_user', this.vm.sys_user_id).subscribe((result: any) => {
        this.vm.item = result;

        // console.log('results: ', this.vm.item);

        // this is a generic preferences template we use to setup a user - it will not be save until
        // after first edit of user, which is required to tune on user in co db
        const prefTemplate = {
          BodyClass: '',
          ShowOps: null,
          default_company_id: '',
          ShowBatches: false,
          QuickLinks: {
            Entities: true,
            Items: true,
            MarginReport: false,
            IncomeStatement: true,
            TransactionDetail: true,
            BalanceSheet: true,
            ReceivableAging: true,
            ReceivableInvoices: true,
            PayableInvoices: true,
            PurchaseOrders: true,
            PurchaseShipments: true,
            SalesOrders: true,
            SalesShipments: true,
            Transfers: true,
            WorkOrders: true,
          },
        };

        const tempPreferences = result.Preferences ? result.Preferences : JSON.stringify(prefTemplate);

        // no template used for perms - is sent from manager when user pushed to the sys_user table based on company registered.
        const tempPermissions = result.Permissions;

        if (tempPermissions) {
          this.vm.Permissions = JSON.parse(tempPermissions);
        }

        // Ensure admin_user boolean is synced with the loaded item property.
        // We use vm.item.admin_user as the primary source for the form checkbox.
        // Reconcile with Permissions.Admin if it exists.
        if (this.vm.Permissions && this.vm.Permissions.Admin !== undefined) {
          this.vm.item.admin_user = !!this.vm.Permissions.Admin;
        }

        if (tempPreferences) {
          this.vm.Preferences = JSON.parse(tempPreferences);
        }

        this.SetValue();
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      }));
    }

    this.subscriptionGroup.push(this.tableDataService
      .getApiListData('company', '?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.company = result.Data;
      }));

    this.subscriptionGroup.push(this.tableDataService
      .getApiListData('sys_user', '?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.allUsers = (result.Data as any[]).filter(u => u.id !== this.vm.sys_user_id);
      }));
  }

  ngAfterViewInit() {
    if (this.vm.sys_user_id !== 'new') {
      this.vm.title = $localize`:Edit @@edit:Edit ` + this.vm.title;
    } else {
      this.vm.title = $localize`:New @@new:New ` + this.vm.title;
    }
    this.titleService.setTitle(this.vm.title);
  }

  onSave(saveClose: boolean) {
    this.submitted = true;

    // console.log('perms: ' + JSON.stringify(this.vm.item.Permissions));
    // console.log('prefs: ' + JSON.stringify(this.vm.item.Preferences));

    if (this.sysUserForm.invalid) {
      this.notification.showWarningToast($localize`:Form Errors! @@formErrors:Form Errors!`);
      return;
    }

    this.sysUser = Object.assign({}, this.sysUserForm.value);

    // to satisfy api model and since we do not allow pw CRUD here
    this.sysUser.password = 'deprecated in api v2';

    this.sysUser.Permissions = JSON.stringify(this.vm.Permissions);

    // this because they originally stored the values as json ... sigh. bad idea, but we can make it work. Move to table later
    // turned into obj on get then set value of props of the obj here and then stringify before store
    this.preferences.default_company_id = this.sysUserForm.get('defaultCompany').value;
    this.preferences.ShowBatches = this.sysUserForm.get('showBatches').value;

    // ql not set here - thru ui and selections made in header - but need to make part of prefs string to save correctly
    this.preferences.QuickLinks = this.vm.Preferences.QuickLinks;

    this.sysUser.Preferences = JSON.stringify(this.preferences);

    // Update Permissions.Admin from the form value
    if (!this.vm.Permissions) {
      this.vm.Permissions = {};
    }
    this.vm.Permissions.Admin = this.sysUserForm.get('admin_user').value;

    this.sysUser.Permissions = JSON.stringify(this.vm.Permissions);

    this.sysUser.admin_user = this.vm.Permissions.Admin;

    this.sysUser.audit_sequence = this.vm.audit_sequence;

    // console.log('perms: ' + this.sysUser.Permissions);
    // console.log('prefs: ' + this.sysUser.Preferences);
    // console.log('sysuser: ' + JSON.stringify(this.sysUser));

    if (this.vm.sys_user_id) {
      if (this.sysUserForm.invalid === false) {
        // console.log('patch new user', this.sysUser);
        this.tableDataService.patch('sys_user', this.vm.sys_user_id, this.sysUser).then(
          (result) => {
            if (saveClose) {
              this.onClose();
            }
            try {
              this.originalSnapshot = this.buildSnapshot();
            } catch {
            }
          },
          (error: HttpErrorResponse) => {
            //
            console.log(error);
          }
        );
        // return true;
      }
    } else {
      // console.log('new user', this.sysUser);
      this.tableDataService.postWithPromise('sys_user', this.sysUser).then((result) => {
        if (saveClose) {
          this.onClose();
        }
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      });

      // this.notification.success($localize`:Saved@@saved:Saved`);
      // this.saveCompanyAccess(this.vm.sys_user_id);
      // return true;
    }
    this.submitted = false;
    return true;
  }

  buildSnapshot(): any {
    try {
      return this.sysUserForm.getRawValue();
    } catch {
      return {};
    }
  }

  hasChanges(): boolean {
    try {
      const current = this.buildSnapshot();
      const original = this.originalSnapshot || {};
      return JSON.stringify(current) !== JSON.stringify(original);
    } catch {
      return false;
    }
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }

  // Permission module config — maps each module master key to its child permission keys.
  // Used by onModuleToggle() to zero-out children when a module is disabled.
  private readonly modulePermissionMap: Record<string, string[]> = {
    Receivables: [
      'EditReceivableEntities', 'ViewReceivableEntities',
      'EditReceivableInvoices', 'ViewReceivableInvoices',
      'EditReceivablePayments', 'ViewReceivablePayments',
      'EditReceivableRecurring',
      'ReceivableAging', 'ReceivableReconciliation',
      'ReceivableInvoices', 'ReceivablePayments', 'ReceivableStatements',
    ],
    Payables: [
      'EditPayableEntities', 'ViewPayableEntities',
      'EditPayableInvoices', 'ViewPayableInvoices',
      'EditPayablePayments', 'ViewPayablePayments',
      'EditPayableRecurring',
      'PayableAging', 'PayableReconciliation',
      'PayableInvoices', 'PayablePayments', 'PayableTaxes',
    ],
    Ledger: [
      'EditJournalEntries', 'ViewJournalEntries',
      'BankReconciliation', 'RecurringJournalEntries',
      'TransactionDetail', 'TrialBalance', 'IncomeStatement', 'BalanceSheet',
    ],
    Dashboards: [
      'DashboardFinancial', 'DashboardInventory', 'DashboardAR', 'DashboardAP',
      'DashboardCRM', 'DashboardGusto', 'DashboardStripe',
      'Chart', 'DashboardIncomeStatement', 'DashboardBalanceSheet',
    ],
    CRM: [
      'EditCRMEntities', 'ViewCRMEntities',
      'EditLeads', 'ViewLeads',
      'EditOpportunities', 'ViewOpportunities',
      'EditEstimates', 'ViewEstimates',
      'EditQuotes', 'ViewQuotes',
      'EditBids', 'ViewBids',
      'EstimatesReport', 'QuotesReport', 'BidsReport',
      'LeadsReport', 'OpportunitiesReport', 'InteractionsReport', 'PipelineReport',
    ],
    Payroll: ['Payroll'],
    Sales: [
      'EditSalesOrders', 'ViewSalesOrders',
      'EditSalesShipments', 'ViewSalesShipments',
      'SalesOrdersReport', 'SalesShipmentsReport',
    ],
    Purchases: [
      'EditPurchaseOrders', 'ViewPurchaseOrders',
      'EditPurchaseShipments', 'ViewPurchaseShipments',
      'PurchaseOrdersReport', 'PurchaseShipmentsReport',
    ],
    Activities: [
      'EditServiceCalls', 'ViewServiceCalls',
      'EditWorkOrders', 'ViewWorkOrders',
      'DispatchWorkOrders', 'BillWorkOrders',
      'EditDeliveries', 'ViewDeliveries',
      'EditTimeSheets', 'ViewTimeSheets', 'ViewAllTime',
      'EditExpenseReports', 'ViewExpenseReports',
      'EditRepairsMaintenance', 'ViewRepairsMaintenance',
      'EditLocationInspections', 'ViewLocationInspections',
      'ManageAssets', 'ManagePmSchedules',
      'ServiceCallsReport', 'WorkOrdersReport', 'DeliveriesReport',
      'TimeSheetsReport', 'ExpenseReportsReport', 'RepairsMaintenanceReport', 'LocationInspectionReport',
    ],
    Projects: [
      'EditProjects', 'ViewProjects',
      'EditProjectBilling',
      'ProjectStatusReport', 'ProjectDetailReport',
      'ProjectTimeReport', 'ProjectProfitabilityReport',
      'ProjectMilestoneReport', 'OverBudgetTasksReport',
    ],
    Inventory: [
      'EditAssemblies', 'ViewAssemblies',
      'EditCounts', 'ViewCounts',
      'EditTransfers', 'ViewTransfers',
      'EditBillsofMaterials', 'ViewBillsofMaterials',
      'EditItems', 'ViewItems',
      'EditItemCategories', 'ViewItemCategories',
      'EditItemPricing', 'ViewItemPricing',
      'EditLocations', 'ViewLocations',
      'ItemBalancesReport', 'AssembliesReport', 'CountsReport', 'TransfersReport',
    ],
    FixedAssets: [
      'EditFixedAssets', 'ViewFixedAssets',
      'EditDepreciation', 'ViewDepreciation',
      'FixedAssetListReport', 'DepreciationScheduleReport', 'FixedAssetDisposalReport',
    ],
    Budget: [
      'EditBudget', 'ViewBudget',
      'BudgetVsActualReport', 'BudgetSummaryReport',
    ],
    SystemSetup: [
      'SetupAccounts', 'SetupAccountMargins', 'SetupAccountSubtotals',
      'SetupBankAccounts', 'SetupBudget', 'SetupCheckStock',
      'SetupCurrency', 'SetupPaymentTypes', 'SetupStripe', 'SetupTaxCodes', 'SetupTerms',
      'SetupFixedAssets',
      'SetupCompany', 'SetupEntityTypes', 'SetupEntities', 'SetupReportingFields', 'SetupSalesperson',
      'SetupInventoryItems', 'SetupItemPricing', 'SetupItemCategories', 'SetupItemGroups', 'SetupItemTypes', 'SetupUOM',
      'SetupLocations', 'SetupLocationGroups',
      'SetupUsers',
    ],
  };

  // Data-driven permission card config — drives the @for loop in the template.
  // Row types: 'editView' = Edit+View pair, 'editOnly' = Edit col only,
  //            'report' = colspan-3 standalone, 'sectionHeader' = bold group label.
  readonly permissionModules: Array<{
    key: string;           // vm.Permissions key for the module master toggle ('' = no master)
    label: string;         // Card header label
    rows: Array<{
      type: 'editView' | 'editOnly' | 'report' | 'sectionHeader';
      label: string;
      editKey?: string;
      viewKey?: string;
      permKey?: string;    // for 'report' / 'editOnly' rows
      conditionalOn?: string; // hide row when vm.Permissions[conditionalOn] is true (e.g. AllEntities)
    }>;
  }> = [
    // Cards ordered tallest → shortest (row count) so the CSS grid packs with minimal gaps:
    // SystemSetup(34), Activities(17), CRM(16), Inventory(15), Receivables(11), Payables(11),
    // Dashboards(11), Ledger(9), FixedAssets(7), Sales(6), Purchases(6), Budget(5), Payroll(1)
    {
      key: 'SystemSetup', label: 'System Setup',
      rows: [
        {type: 'sectionHeader', label: 'Financial'},
        {type: 'report', label: 'Accounts', permKey: 'SetupAccounts'},
        {type: 'report', label: 'Account Margins', permKey: 'SetupAccountMargins'},
        {type: 'report', label: 'Account Subtotals', permKey: 'SetupAccountSubtotals'},
        {type: 'report', label: 'Bank Accounts', permKey: 'SetupBankAccounts'},
        {type: 'report', label: 'Budget', permKey: 'SetupBudget'},
        {type: 'report', label: 'Check Stock', permKey: 'SetupCheckStock'},
        {type: 'report', label: 'Currency', permKey: 'SetupCurrency'},
        {type: 'report', label: 'Payment Types', permKey: 'SetupPaymentTypes'},
        {type: 'report', label: 'Stripe', permKey: 'SetupStripe'},
        {type: 'report', label: 'Tax Codes', permKey: 'SetupTaxCodes'},
        {type: 'report', label: 'Terms', permKey: 'SetupTerms'},
        {type: 'sectionHeader', label: 'Fixed Assets'},
        {type: 'report', label: 'Fixed Assets Config', permKey: 'SetupFixedAssets'},
        {type: 'sectionHeader', label: 'General'},
        {type: 'report', label: 'Company', permKey: 'SetupCompany'},
        {type: 'report', label: 'Entity Types', permKey: 'SetupEntityTypes'},
        {type: 'report', label: 'Entities', permKey: 'SetupEntities'},
        {type: 'report', label: 'Reporting Fields', permKey: 'SetupReportingFields'},
        {type: 'report', label: 'Salesperson', permKey: 'SetupSalesperson'},
        {type: 'sectionHeader', label: 'Inventory'},
        {type: 'report', label: 'Inventory Items', permKey: 'SetupInventoryItems'},
        {type: 'report', label: 'Item Pricing', permKey: 'SetupItemPricing'},
        {type: 'report', label: 'Item Categories', permKey: 'SetupItemCategories'},
        {type: 'report', label: 'Item Groups', permKey: 'SetupItemGroups'},
        {type: 'report', label: 'Item Types', permKey: 'SetupItemTypes'},
        {type: 'report', label: 'Unit of Measure', permKey: 'SetupUOM'},
        {type: 'sectionHeader', label: 'Location'},
        {type: 'report', label: 'Locations', permKey: 'SetupLocations'},
        {type: 'report', label: 'Location Groups', permKey: 'SetupLocationGroups'},
        {type: 'sectionHeader', label: 'Users'},
        {type: 'report', label: 'Users', permKey: 'SetupUsers'},
      ],
    },
    {
      key: 'Activities', label: 'Activities',
      rows: [
        {type: 'sectionHeader', label: 'Transactions'},
        {type: 'editView', label: 'Service Calls', editKey: 'EditServiceCalls', viewKey: 'ViewServiceCalls'},
        {type: 'editView', label: 'Work Orders', editKey: 'EditWorkOrders', viewKey: 'ViewWorkOrders'},
        {type: 'editOnly', label: 'Dispatch Work Orders', permKey: 'DispatchWorkOrders'},
        {type: 'editOnly', label: 'Bill Work Orders', permKey: 'BillWorkOrders'},
        {type: 'editView', label: 'Deliveries', editKey: 'EditDeliveries', viewKey: 'ViewDeliveries'},
        {type: 'editView', label: 'Time Sheets', editKey: 'EditTimeSheets', viewKey: 'ViewTimeSheets'},
        {type: 'editOnly', label: 'View All Time', permKey: 'ViewAllTime'},
        {type: 'editView', label: 'Expense Reports', editKey: 'EditExpenseReports', viewKey: 'ViewExpenseReports'},
        {type: 'editView', label: 'Repairs & Maintenance', editKey: 'EditRepairsMaintenance', viewKey: 'ViewRepairsMaintenance'},
        {type: 'editView', label: 'Location Inspections', editKey: 'EditLocationInspections', viewKey: 'ViewLocationInspections'},
        {type: 'editOnly', label: 'Manage Assets', permKey: 'ManageAssets'},
        {type: 'editOnly', label: 'Manage PM Schedules', permKey: 'ManagePmSchedules'},
        {type: 'sectionHeader', label: 'Reports'},
        {type: 'report', label: 'Service Calls', permKey: 'ServiceCallsReport'},
        {type: 'report', label: 'Work Orders', permKey: 'WorkOrdersReport'},
        {type: 'report', label: 'Deliveries', permKey: 'DeliveriesReport'},
        {type: 'report', label: 'Time Sheets', permKey: 'TimeSheetsReport'},
        {type: 'report', label: 'Expense Reports', permKey: 'ExpenseReportsReport'},
        {type: 'report', label: 'Repairs & Maintenance', permKey: 'RepairsMaintenanceReport'},
        {type: 'report', label: 'Location Inspections', permKey: 'LocationInspectionReport'},
      ],
    },
    {
      key: 'Projects', label: 'Projects',
      rows: [
        {type: 'sectionHeader', label: 'Transactions'},
        {type: 'editView', label: 'Projects', editKey: 'EditProjects', viewKey: 'ViewProjects'},
        {type: 'editOnly', label: 'Project Billing / Invoicing', permKey: 'EditProjectBilling'},
        {type: 'sectionHeader', label: 'Reports'},
        {type: 'report', label: 'Project Status', permKey: 'ProjectStatusReport'},
        {type: 'report', label: 'Project Detail', permKey: 'ProjectDetailReport'},
        {type: 'report', label: 'Project Time', permKey: 'ProjectTimeReport'},
        {type: 'report', label: 'Project Profitability', permKey: 'ProjectProfitabilityReport'},
        {type: 'report', label: 'Project Milestones', permKey: 'ProjectMilestoneReport'},
        {type: 'report', label: 'Over Budget Tasks', permKey: 'OverBudgetTasksReport'},
      ],
    },
    {
      key: 'CRM', label: 'CRM',
      rows: [
        {type: 'editView', label: 'Entities', editKey: 'EditCRMEntities', viewKey: 'ViewCRMEntities', conditionalOn: 'AllEntities'},
        {type: 'sectionHeader', label: 'Transactions'},
        {type: 'editView', label: 'Leads', editKey: 'EditLeads', viewKey: 'ViewLeads'},
        {type: 'editView', label: 'Opportunities', editKey: 'EditOpportunities', viewKey: 'ViewOpportunities'},
        {type: 'editView', label: 'Estimates', editKey: 'EditEstimates', viewKey: 'ViewEstimates'},
        {type: 'editView', label: 'Quotes', editKey: 'EditQuotes', viewKey: 'ViewQuotes'},
        {type: 'editView', label: 'Bids', editKey: 'EditBids', viewKey: 'ViewBids'},
        {type: 'sectionHeader', label: 'Reports'},
        {type: 'report', label: 'Leads', permKey: 'LeadsReport'},
        {type: 'report', label: 'Opportunities', permKey: 'OpportunitiesReport'},
        {type: 'report', label: 'Estimates', permKey: 'EstimatesReport'},
        {type: 'report', label: 'Quotes', permKey: 'QuotesReport'},
        {type: 'report', label: 'Bids', permKey: 'BidsReport'},
        {type: 'report', label: 'Interactions', permKey: 'InteractionsReport'},
        {type: 'report', label: 'Pipeline', permKey: 'PipelineReport'},
      ],
    },
    {
      key: 'Inventory', label: 'Inventory',
      rows: [
        {type: 'sectionHeader', label: 'Transactions'},
        {type: 'editView', label: 'Assemblies', editKey: 'EditAssemblies', viewKey: 'ViewAssemblies'},
        {type: 'editView', label: 'Counts', editKey: 'EditCounts', viewKey: 'ViewCounts'},
        {type: 'editView', label: 'Transfers', editKey: 'EditTransfers', viewKey: 'ViewTransfers'},
        {type: 'sectionHeader', label: 'Lists'},
        {type: 'editView', label: 'Bills of Materials', editKey: 'EditBillsofMaterials', viewKey: 'ViewBillsofMaterials'},
        {type: 'editView', label: 'Items', editKey: 'EditItems', viewKey: 'ViewItems'},
        {type: 'editView', label: 'Item Categories', editKey: 'EditItemCategories', viewKey: 'ViewItemCategories'},
        {type: 'editView', label: 'Item Pricing', editKey: 'EditItemPricing', viewKey: 'ViewItemPricing'},
        {type: 'editView', label: 'Locations', editKey: 'EditLocations', viewKey: 'ViewLocations'},
        {type: 'sectionHeader', label: 'Reports'},
        {type: 'report', label: 'Item Balances', permKey: 'ItemBalancesReport'},
        {type: 'report', label: 'Assemblies', permKey: 'AssembliesReport'},
        {type: 'report', label: 'Counts', permKey: 'CountsReport'},
        {type: 'report', label: 'Transfers', permKey: 'TransfersReport'},
      ],
    },
    {
      key: 'Receivables', label: 'Receivables',
      rows: [
        {
          type: 'editView',
          label: 'Entities',
          editKey: 'EditReceivableEntities',
          viewKey: 'ViewReceivableEntities',
          conditionalOn: 'AllEntities'
        },
        {type: 'sectionHeader', label: 'Transactions'},
        {type: 'editView', label: 'Invoices', editKey: 'EditReceivableInvoices', viewKey: 'ViewReceivableInvoices'},
        {type: 'editView', label: 'Payments', editKey: 'EditReceivablePayments', viewKey: 'ViewReceivablePayments'},
        {type: 'editOnly', label: 'Recurring', permKey: 'EditReceivableRecurring'},
        {type: 'sectionHeader', label: 'Reports'},
        {type: 'report', label: 'Aging', permKey: 'ReceivableAging'},
        {type: 'report', label: 'Reconciliation', permKey: 'ReceivableReconciliation'},
        {type: 'report', label: 'Invoices', permKey: 'ReceivableInvoices'},
        {type: 'report', label: 'Payments', permKey: 'ReceivablePayments'},
        {type: 'report', label: 'Statements', permKey: 'ReceivableStatements'},
      ],
    },
    {
      key: 'Payables', label: 'Payables',
      rows: [
        {type: 'editView', label: 'Entities', editKey: 'EditPayableEntities', viewKey: 'ViewPayableEntities', conditionalOn: 'AllEntities'},
        {type: 'sectionHeader', label: 'Transactions'},
        {type: 'editView', label: 'Invoices', editKey: 'EditPayableInvoices', viewKey: 'ViewPayableInvoices'},
        {type: 'editView', label: 'Payments', editKey: 'EditPayablePayments', viewKey: 'ViewPayablePayments'},
        {type: 'editOnly', label: 'Recurring', permKey: 'EditPayableRecurring'},
        {type: 'sectionHeader', label: 'Reports'},
        {type: 'report', label: 'Aging', permKey: 'PayableAging'},
        {type: 'report', label: 'Reconciliation', permKey: 'PayableReconciliation'},
        {type: 'report', label: 'Invoices', permKey: 'PayableInvoices'},
        {type: 'report', label: 'Payments', permKey: 'PayablePayments'},
        {type: 'report', label: 'Taxes', permKey: 'PayableTaxes'},
      ],
    },
    {
      key: 'Dashboards', label: 'Dashboards',
      rows: [
        {type: 'report', label: 'Financial Dashboard', permKey: 'DashboardFinancial'},
        {type: 'report', label: 'Inventory Dashboard', permKey: 'DashboardInventory'},
        {type: 'report', label: 'AR Dashboard', permKey: 'DashboardAR'},
        {type: 'report', label: 'AP Dashboard', permKey: 'DashboardAP'},
        {type: 'report', label: 'CRM Dashboard', permKey: 'DashboardCRM'},
        {type: 'report', label: 'Gusto Dashboard', permKey: 'DashboardGusto'},
        {type: 'report', label: 'Stripe Dashboard', permKey: 'DashboardStripe'},
        {type: 'sectionHeader', label: 'Widgets'},
        {type: 'report', label: 'Chart', permKey: 'Chart'},
        {type: 'report', label: 'Income Statement', permKey: 'DashboardIncomeStatement'},
        {type: 'report', label: 'Balance Sheet', permKey: 'DashboardBalanceSheet'},
      ],
    },
    {
      key: 'Ledger', label: 'General Ledger',
      rows: [
        {type: 'sectionHeader', label: 'Transactions'},
        {type: 'editView', label: 'Journal Entries', editKey: 'EditJournalEntries', viewKey: 'ViewJournalEntries'},
        {type: 'editOnly', label: 'Bank Reconciliation', permKey: 'BankReconciliation'},
        {type: 'editOnly', label: 'Recurring Journal Entries', permKey: 'RecurringJournalEntries'},
        {type: 'sectionHeader', label: 'Reports'},
        {type: 'report', label: 'Transaction Detail', permKey: 'TransactionDetail'},
        {type: 'report', label: 'Trial Balance', permKey: 'TrialBalance'},
        {type: 'report', label: 'Income Statement', permKey: 'IncomeStatement'},
        {type: 'report', label: 'Balance Sheet', permKey: 'BalanceSheet'},
      ],
    },
    {
      key: 'FixedAssets', label: 'Fixed Assets',
      rows: [
        {type: 'sectionHeader', label: 'Transactions'},
        {type: 'editView', label: 'Fixed Assets', editKey: 'EditFixedAssets', viewKey: 'ViewFixedAssets'},
        {type: 'editView', label: 'Depreciation', editKey: 'EditDepreciation', viewKey: 'ViewDepreciation'},
        {type: 'sectionHeader', label: 'Reports'},
        {type: 'report', label: 'Asset List', permKey: 'FixedAssetListReport'},
        {type: 'report', label: 'Depreciation Schedule', permKey: 'DepreciationScheduleReport'},
        {type: 'report', label: 'Asset Disposals', permKey: 'FixedAssetDisposalReport'},
      ],
    },
    {
      key: 'Sales', label: 'Sales',
      rows: [
        {type: 'sectionHeader', label: 'Transactions'},
        {type: 'editView', label: 'Orders', editKey: 'EditSalesOrders', viewKey: 'ViewSalesOrders'},
        {type: 'editView', label: 'Shipments', editKey: 'EditSalesShipments', viewKey: 'ViewSalesShipments'},
        {type: 'sectionHeader', label: 'Reports'},
        {type: 'report', label: 'Orders', permKey: 'SalesOrdersReport'},
        {type: 'report', label: 'Shipments', permKey: 'SalesShipmentsReport'},
      ],
    },
    {
      key: 'Purchases', label: 'Purchases',
      rows: [
        {type: 'sectionHeader', label: 'Transactions'},
        {type: 'editView', label: 'Orders', editKey: 'EditPurchaseOrders', viewKey: 'ViewPurchaseOrders'},
        {type: 'editView', label: 'Shipments', editKey: 'EditPurchaseShipments', viewKey: 'ViewPurchaseShipments'},
        {type: 'sectionHeader', label: 'Reports'},
        {type: 'report', label: 'Orders', permKey: 'PurchaseOrdersReport'},
        {type: 'report', label: 'Shipments', permKey: 'PurchaseShipmentsReport'},
      ],
    },
    {
      key: 'Budget', label: 'Budget',
      rows: [
        {type: 'sectionHeader', label: 'Transactions'},
        {type: 'editView', label: 'Budget', editKey: 'EditBudget', viewKey: 'ViewBudget'},
        {type: 'sectionHeader', label: 'Reports'},
        {type: 'report', label: 'Budget vs Actual', permKey: 'BudgetVsActualReport'},
        {type: 'report', label: 'Budget Summary', permKey: 'BudgetSummaryReport'},
      ],
    },
    {
      key: 'Payroll', label: 'Payroll',
      rows: [
        {type: 'report', label: 'Payroll', permKey: 'Payroll'},
      ],
    },
  ];

  // Returns the 3-state access level for an editView row: 'edit' | 'view' | 'none'
  getAccessLevel(editKey: string, viewKey: string): string {
    if (this.vm.Permissions[editKey]) {
      return 'edit';
    }
    if (this.vm.Permissions[viewKey]) {
      return 'view';
    }
    return 'none';
  }

  // Sets editKey/viewKey based on the 3-state radio selection
  setAccessLevel(editKey: string, viewKey: string, level: string): void {
    this.vm.Permissions[editKey] = level === 'edit';
    this.vm.Permissions[viewKey] = level === 'view';
  }

  // Called when the Admin User checkbox is toggled.
  // When turned ON, clears all module-level and child permissions (admin implies full access).
  onAdminToggle(): void {
    if (this.sysUserForm.get('admin_user').value) {
      // Clear every key in vm.Permissions except Admin itself
      Object.keys(this.vm.Permissions).forEach(key => {
        if (key !== 'Admin') {
          this.vm.Permissions[key] = false;
        }
      });
    }
  }

  // Called when a module master checkbox is toggled.
  // If the module is being turned OFF, zero out all its child permissions.
  onModuleToggle(moduleKey: string): void {
    if (!this.vm.Permissions[moduleKey]) {
      const children = this.modulePermissionMap[moduleKey] ?? [];
      children.forEach(child => this.vm.Permissions[child] = false);
    }
  }

  // Called when a View Only checkbox is toggled.
  // If View Only is being turned ON, clear the corresponding Edit flag.
  onViewOnlyToggle(viewKey: string, editKey: string): void {
    if (this.vm.Permissions[viewKey]) {
      this.vm.Permissions[editKey] = false;
    }
  }

  copyPermissionsFrom(): void {
    if (!this.selectedCopyUserId) {
      return;
    }
    const source = (this.vm.allUsers as any[]).find(u => u.id === this.selectedCopyUserId);
    if (!source || !source.Permissions) {
      return;
    }
    const copied = JSON.parse(source.Permissions);
    // Preserve the current user's Admin flag — do not overwrite it from the source
    const currentAdmin = this.vm.Permissions.Admin;
    this.vm.Permissions = {...copied, Admin: currentAdmin};
    // Sync admin_user form control
    this.sysUserForm.patchValue({admin_user: !!currentAdmin});
    this.notification.showSuccessToast(`Permissions copied from ${source.name}`);
  }

// TODO add in company and enity access here after we figure out subscription scheme as it relates to multicompany access by user by fee etc.
  saveCompanyAccess(id) {
    for (const company of this.vm.company) {
      if (company.access === true) {
        this.vm.tempCompanyAccess = { user_id: id, company_id: company.id };
        this.tableDataService.post('company_access', this.vm.tempCompanyAccess).pipe(take(1))
          .subscribe({
            next: (item: any) => {
            // this.notification.success('Company Access Updated');
          },
           error: (err: any) => {
            this.notification.showWarningToast(
              $localize`:Company access in User Setup failed @@companyAccessInUserSetupFailed:Company access in User Setup failed`
            );
            console.log(err.message);
          },
          complete: () => {
          },
      });
      }
    }
  }
}

